import React, { useEffect } from 'react'
import { useRef } from 'react'

type InfiniteScrollProps = {
    onIntersect?: () => void
}

export const InfiniteScroll = ({ onIntersect }: InfiniteScrollProps) => {
    const observerRef = useRef<IntersectionObserver | null>(null)
    const targetRef = useRef<HTMLDivElement | null>(null)

    useEffect(() => {
        // Create an IntersectionObserver
        observerRef.current = new IntersectionObserver((entries) => {
            const target = entries[0]
            if (target.isIntersecting) {
                onIntersect?.()
            }
        })

        // Observe the target element
        if (targetRef.current) {
            observerRef.current.observe(targetRef.current)
        }

        // Cleanup observer on component unmount
        return () => {
            if (observerRef.current && targetRef.current) {
                observerRef.current.unobserve(targetRef.current)
            }
        }
    }, [onIntersect])

    return <div ref={targetRef} />
}
